import { Base } from "ui/Scripts/source/framework/base";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";

export interface IUsersPageUserGroups {
    userGroups: IIdTitleNode[];
}

export class UsersPageUserGroups implements IUsersPageUserGroups {
    userGroups: IdTitleNode[];

    constructor();
    constructor(obj: IUsersPageUserGroups);
    constructor(obj?: any) {
        this.userGroups = Base.getTypedArray(obj ? obj.userGroups : null, IdTitleNode);
    }
}